export enum SystemOriginatorEnum {
  // removed enums                        20230412 AK 
 // 'Quick Money' = 1,
  // 'SureCollect' =2,
  'MaxMoney'= 3,
  // 'Everest' = 4,
  // 'iWizz' = 5,
  // 'Pythuis' = 6,
  // 'BizBank' = 7,
  // 'Flexifusion' = 8,
  'Acpas' = 9,
  //"AfricanMobile" = 10,
  //"GroupRUs" = 11,
  //"Flexisoft" = 12,
  'Neptus'  = 10,
  'Access Bank' = 11,
  'Africa Mobile' = 12,
  'GroupRUs' = 13,
  'Flexisoft' = 14,
  'RubiBlue' = 15,
  'Allworth' = 16,
  // 'No Integration' = 17,
  'AlgoHive' = 18,
  'PaydayLoans' = 19,
  'Experian' = 20,
  // 21 is the new enum for LoanSquare 2026-11-02 NS
  'LoanSquare' = 21
}

export namespace SystemOriginatorEnum {
  export function values() {
    return Object.keys(SystemOriginatorEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
